<span class="app-badges-container">
    <img src="assets/images/app_badges/appleApp.png" class="app-badges" alt="app-badges" (click)="openAppleStoreLink()">
</span>
<span class="app-badges-container">
    <img src="assets/images/app_badges/googlePlay.png" class="app-badges" alt="app-badges"
        (click)="openAndriodStoreLink()">
</span>
